if (document.readyState === "loading") {
  // Declare translations only if it's not already defined
  let reqtranslations = {
  en: {
    requiredFields: "Please fill in all required(*) fields",
    uploadPrescription: "Please upload a prescription file",
    validFullName: "Please enter a valid full name (minimum 2 characters)",
    validPhoneNumber: "Please enter a valid 8-digit phone number [eg: 31234567].",
    validEmailAddress: "Please enter a valid email address.",
    selectArea: "Please select an area.",
    uploadInsuranceCard: "Please upload an insurance card.",
    uploadClaimFile: "Please upload a claim file.",
    uploadQatarID: "Please upload a Qatar ID.",
   
  },
  ar: {
    requiredFields: "يرجى ملء جميع الحقول المطلوبة (*)",
    uploadPrescription: "يرجى تحميل ملف الوصفة الطبية",
    validFullName: "يرجى إدخال اسم كامل صالح (حد أدنى حرفان)",
    validPhoneNumber: "يرجى إدخال رقم هاتف صالح مكون من 8 أرقام [مثال: 31234567].",
    validEmailAddress: "يرجى إدخال عنوان بريد إلكتروني صالح.",
    selectArea: "يرجى اختيار منطقة.",
    uploadInsuranceCard: "يرجى تحميل بطاقة التأمين.",
    uploadClaimFile: "يرجى تحميل ملف المطالبة.",
    uploadQatarID: "يرجى تحميل بطاقة الهوية القطرية.",
   
  },
};

 document.addEventListener("DOMContentLoaded", onPageLoad);
} else {
  onPageLoad();
}


function onPageLoad() {
  // Form Validation
  const message_div = document.getElementById("message_show");

    if (message_div) {
        message_div.textContent = ""; // ✅ Only run if the element exists
    } else {
        console.warn("Element with id='message_show' not found.");
    }

  // Required Fields
  const fullNameInput = document.getElementById("ContactForm-name");
  const phoneInput = document.getElementById("ContactForm-phone");
  const emailInput = document.getElementById("ContactForm-email");
  const productInput = document.getElementById("ContactForm-product"); // Added product field reference
  const prodDescription= document.getElementById("ContactForm-body"); 
  const requestProduct = document.getElementById("requestProduct");
  const productFile = document.getElementById("ContactForm-product-file");


  // Language Settings
  const currentLanguage = document.documentElement.lang || "en";

  function showError(input, messageKey) {
    const message = (typeof reqtranslations !== "undefined" && reqtranslations[currentLanguage] && reqtranslations[currentLanguage][messageKey]) 
        ? reqtranslations[currentLanguage][messageKey] 
        : messageKey; // Fallback if reqtranslations is missing

    input.classList.add("error-field");
    input.setAttribute("aria-invalid", "true");

    if (!input.parentNode.querySelector(".field-error")) {
      const errorSpan = document.createElement("span");
      errorSpan.className = "field-error";
      errorSpan.textContent = message;
      input.parentNode.appendChild(errorSpan);
      errorSpan.setAttribute("tabindex", "-1");
      errorSpan.focus();
      errorSpan.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function clearError(input) {
    const errorSpan = input.parentNode.querySelector(".field-error");
    if (errorSpan) {
      errorSpan.remove();
    }
    input.classList.remove("error-field");
    input.setAttribute("aria-invalid", "false");
  }

  function validateName(name) {
    return name.trim().length >= 2;
  }

  function validatePhone(phoneNumber) {
    if (/^\+974[3567][0-9]{7}$/.test(phoneNumber)) {
      phoneNumber = phoneNumber.replace(/^\+974/, "");
    }

    return /^[3567][0-9]{7}$/.test(phoneNumber);
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function validateProductName(product) {
    return product.trim().length > 0; // Ensures the product name is not empty
  }

  function validateForm() {
    let isValid = true;
    if (!validateName(fullNameInput.value)) {
      showError(fullNameInput, "Please enter a valid name");
      isValid = false;
    }
    if (!validatePhone(phoneInput.value)) {
      showError(phoneInput, "Please enter a valid 8-digit phone number");
      isValid = false;
    }
    if (!validateEmail(emailInput.value)) {
      showError(emailInput, "Please enter a valid email address");
      isValid = false;
    }
    if (!validateProductName(productInput.value)) {
      showError(productInput, "Product name is required"); // Added product validation
      isValid = false;
    }
    return isValid;
  }

  // Clear errors on input
  fullNameInput.addEventListener("input", () => clearError(fullNameInput));
  phoneInput.addEventListener("input", () => clearError(phoneInput));
  emailInput.addEventListener("input", () => clearError(emailInput));
  productInput.addEventListener("input", () => clearError(productInput)); // Added event listener for product field

  if (requestProduct) {
    requestProduct.addEventListener("click", function () {
      const form = document.getElementById("requestproductForm");
       form.classList.add("submitting");

      const maxFileSize = 2 * 1024 * 1024; // 2 MB in bytes

      const mainProduct = document.getElementById("ContactForm-product-file").files;
       if (!validateFiles(mainProduct, maxFileSize, "Product")) return;
      const formData = new FormData(form); 
      formData.append("action", "product_request");
       const file1 = formData.get("contact[product_file]");
      formData.append("ProductFile", file1);
      const desc = formData.get("contact[body]");
       formData.append("customer_id", ShopifyAnalytics.meta.page.customerId);

      if (validateForm()) {
       

        fetch("https://www.sahasralifecare.com/api/request/post.php", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success === true) {
               message_div.style.display = "block";
               message_div.textContent ="Form Submitted Successfully";
             // console.log("Form submitted successfully:", data.message);
              if (message_div.classList.contains("error")) {
                message_div.classList.remove("error");
              } 
               message_div.classList.add("success");
               const fileInputs = document.querySelectorAll('#requestproductForm input[type="file"]');
               const fileDisplaySpans = document.querySelectorAll("#requestproductForm .file-names-display");
                  // Iterate through each file input and reset its value
                fileInputs.forEach((fileInput) => {
                  fileInput.value = "";
                });
               // Iterate through each span displaying the file name and clear its text
                fileDisplaySpans.forEach((span) => {
                  span.textContent = "No files selected"; // Reset displayed text
                });
              form.reset();
              setTimeout(() => {
                message_div.style.display = "none";
              }, 5000);
            } else {
              console.log("Form submission failed:", data.message);
              message_div.style.display = "block";
              message_div.textContent ="Form Submission Failed";
               if (message_div.classList.contains("success")) {
                message_div.classList.remove("success");
              }
              message_div.classList.add("error");
            }
          })
          .catch((error) => {
            console.error("Error submitting form:", error);
            message_div.textContent =
              "There was an error submitting the form. Check the console for details.";
             message_div.classList.add("error");
          });
      } else {
        message_div.style.display = "none"; message_div.classList.add("error");
      }
    });
  }
}
// Function to validate files
function validateFiles(files, maxSize, type) {
  for (const file of files) {
    if (file.size > maxSize) {
      document.getElementById("error").textContent = `A ${type} file "${
        file.name
      }" exceeds the size limit of ${maxSize / (1024 * 1024)} MB.`;
      return false;
    }
  }
  return true;
}